export const TIME_5000 = 5000;
export const TIME_10000 = 10000;
